import * as types from '../../constants/log/loginLogConstants';

export const loginLogListRequest = (
  {
    page,
    pageLength,
    beginDate,
    endDate,
    searchString,
    callback,
    error
  }
) => ({
  type: types.LOGINLOG_LIST_REQUEST,
  page,
  pageLength,
  beginDate,
  endDate,
  searchString,
  callback,
  error
});

export const loginLogList = (list) => ({
  type: types.LOGINLOG_LIST,
  list
});

export const setTotalCount = (totalCount) => ({
  type: types.SET_TOTAL_COUNT,
  totalCount,
});

export const setLoginLogPagination = (
  page, totalCount, beginDate, endDate, searchString
) => ({
  type: types.SET_LOGINLOG_PAGINATION,
  page,
  totalCount,
  beginDate,
  endDate,
  searchString,
});

export const loginLogPageReset = () => ({
  type: types.LOGINLOG_PAGE_RESET,
});
